import React, { useState } from "react";
import Header from "./Header";
import SeperatePricingContainer from "./SeperatePricingContainer";
import InquiryForm from "./InquiryForm";
import Testimonials from "./Testimonials";
import FaqCardComponent from "./FaqCardComponent";
import Gallery from "./Gallery";
import ReferAndEarn from "./ReferAndEarn";
import StatsSection from "./StatsSection";
import RollingBrands from "./RollingBrands";
import Quotation from "./Quotation";
import QuotationComponent from "./QuotationComponent";
import ChooseUs from "./ChooseUs";

const Homepage = () => {
  const [showQuotation, setShowQuotation] = useState(false);

  const openQuotation = () => setShowQuotation(true);
  const closeQuotation = () => setShowQuotation(false);

  return (
    <div className="homepage relative mt-4">
      <Header />
      <div className="hero text-center py-10">
        <div className="relative my-6 p-5 pt-0 w-full sm:h-[60vh] md:h-[90vh]">
          <img
            src="/images/imagewall.jpg"
            alt="
Affordable interior designers in Hyderabad
Budget-friendly interior design services in Hyderabad
Best interior designers in Hyderabad
Top-rated interior designers in Hyderabad
Interior design companies in Hyderabad
Professional interior designers in Hyderabad
Interior design services in Hyderabad
Interior decorators in Hyderabad
Home interior designers in Hyderabad
Residential interior designers in Hyderabad
Commercial interior designers in Hyderabad
Interior design firms in Hyderabad
Interior design solutions in Hyderabad
Interior design experts in Hyderabad
Interior design consultants in Hyderabad
Interior design specialists in Hyderabad
Interior design professionals in Hyderabad
Interior design contractors in Hyderabad
Interior design agencies in Hyderabad
Interior design studios in Hyderabad
Interior design businesses in Hyderabad
Interior design shops in Hyderabad
Interior design showrooms in Hyderabad
Interior design retailers in Hyderabad
Interior design suppliers in Hyderabad
Interior design manufacturers in Hyderabad
Interior design wholesalers in Hyderabad
Interior design distributors in Hyderabad
Interior design importers in Hyderabad
Interior design exporters in Hyderabad
Interior design dealers in Hyderabad
Interior design traders in Hyderabad
Interior design consultants in Hyderabad
Interior design advisors in Hyderabad
Interior design planners in Hyderabad
Interior design coordinators in Hyderabad
Interior design managers in Hyderabad
Interior design directors in Hyderabad
Interior design executives in Hyderabad
Interior design assistants in Hyderabad
Interior design associates in Hyderabad
Interior design trainees in Hyderabad
Interior design apprentices in Hyderabad
Interior design interns in Hyderabad
Interior design volunteers in Hyderabad
Interior design enthusiasts in Hyderabad
Interior design hobbyists in Hyderabad
Interior design students in Hyderabad
Interior design graduates in Hyderabad
Interior design professionals in Hyderabad
Interior design experts in Hyderabad
Interior design specialists in Hyderabad
Interior design consultants in Hyderabad
Interior design advisors in Hyderabad
Interior design planners in Hyderabad
Interior design coordinators in Hyderabad
Interior design managers in Hyderabad
Interior design directors in Hyderabad
Interior design executives in Hyderabad
Interior design assistants in Hyderabad
Interior design associates in Hyderabad
Interior design trainees in Hyderabad
Interior design apprentices in Hyderabad
Interior design interns in Hyderabad
Interior design volunteers in Hyderabad
Interior design enthusiasts in Hyderabad
Interior design hobbyists in Hyderabad
Interior design students in Hyderabad
Interior design graduates in Hyderabad
Interior design professionals in Hyderabad
Interior design experts in Hyderabad
Interior design specialists in Hyderabad
Interior design consultants in Hyderabad
Interior design advisors in Hyderabad
Interior design planners in Hyderabad
Interior design coordinators in Hyderabad
Interior design managers in Hyderabad
Interior design directors in Hyderabad
Interior design executives in Hyderabad
Interior design assistants in Hyderabad
Interior design associates in Hyderabad
Interior design trainees in Hyderabad
Interior design apprentices in Hyderabad
Interior design interns in Hyderabad
Interior design volunteers in Hyderabad
Interior design enthusiasts in Hyderabad
Interior design hobbyists in Hyderabad
Interior design students in Hyderabad
Interior design graduates in Hyderabad
Interior design professionals in Hyderabad
Interior design experts in Hyderabad
Interior design specialists in Hyderabad
Interior design consultants in Hyderabad
Interior design advisors in Hyderabad
Interior design planners in Hyderabad
Interior design coordinators in Hyderabad
Interior design managers in Hyderabad
Interior design directors in Hyderabad
Interior design executives in Hyderabad
Interior design assistants in Hyderabad
Interior design associates in Hyderabad
Interior design trainees in Hyderabad
Interior design apprentices in Hyderabad
Interior design interns in Hyderabad
Interior design volunteers in Hyderabad
Interior design enthusiasts in Hyderabad
Interior design hobbyists in Hyderabad
Interior design students in Hyderabad
Interior design graduates in Hyderabad
Interior design professionals in Hyderabad
Interior design experts in Hyderabad
Interior design specialists in Hyderabad
Interior design consultants in Hyderabad
Interior design advisors in Hyderabad
Interior design planners in Hyderabad
Interior design coordinators in Hyderabad
Interior design managers in Hyderabad
Interior design directors in Hyderabad
Interior design executives in Hyderabad
Interior design assistants in Hyderabad
Interior design associates in Hyderabad
Interior design trainees in Hyderabad
Interior design apprentices in Hyderabad
Interior design interns in Hyderabad
Interior design volunteers in Hyderabad"
            className="w-full h-full object-cover object-center rounded-xl"
          />

          {/* Form appears on top of the image in desktop view */}
          <div className="absolute top-[15vh] right-0 sm:right-[5%] w-full sm:w-[35%] md:w-[35%] h-auto bg-white bg-opacity-100 rounded-xl hidden md:block">
            <div className="flex flex-col sm:flex-row justify-center items-center w-full h-auto p-4">
              <InquiryForm />
            </div>
          </div>
        </div>

        {/* Form appears below the image in mobile view */}
        <div className="sm:hidden w-full px-4 pb-4">
          <InquiryForm />
        </div>

        <div className="p-8 sm:p-12">
          <ChooseUs />
        </div>
        {/* Quotation Section */}
        <div className="p-8 sm:p-12">
          <QuotationComponent openQuotation={openQuotation} />
        </div>

        <div className="p-8 sm:p-12">
          <RollingBrands />
        </div>
        <div className="p-3 sm:p-8">
          <SeperatePricingContainer />
        </div>
        <div className="p-8 sm:p-12">
          <Gallery />
        </div>
        <div className="p-8 sm:p-12">
          <StatsSection />
        </div>

        <div className="p-8 sm:p-12">
          <ReferAndEarn />
        </div>
        <div className="p-8 sm:p-12">
          <Testimonials />
        </div>
        <FaqCardComponent />
      </div>

      {/* Quotation Modal */}
      {showQuotation && (
        <div className="fixed inset-0 z-50 flex justify-center items-center bg-black bg-opacity-50 backdrop-blur-sm">
          <div className="bg-white p-6 rounded-xl shadow-xl w-[90%] max-w-md sm:w-96">
            <div className="flex justify-between items-center mb-4">
              <h2 className="text-l ">Know your estimate</h2>
              <button
                className="text-gray-500 hover:text-gray-800"
                onClick={closeQuotation}
              >
                ✖
              </button>
            </div>
            <Quotation />
          </div>
        </div>
      )}
    </div>
  );
};

export default Homepage;
